/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Animal_Scientific_NameInputs */

const en_attribute_animal_scientific_name = /** @type {(inputs: Attribute_Animal_Scientific_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animal scientific name`)
};

/**
* | output |
* | --- |
* | "Animal scientific name" |
*
* @param {Attribute_Animal_Scientific_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_animal_scientific_name = /** @type {((inputs?: Attribute_Animal_Scientific_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Animal_Scientific_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_animal_scientific_name(inputs)
});